module.exports = __webpack_public_path__ + "8062ca857fe0b63732d4ff496e7033e2.svg";